document.addEventListener('DOMContentLoaded', function() {
  var body = document.body;
  if (!body) return;

  // Strict gate: only run on AW2026 collection template pages.
  var isAwTemplate = body.classList.contains('aw-2026') && body.className.indexOf('template-collection') !== -1;
  if (!isAwTemplate) return;

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.aw-reveal, .aw-product, .aw-visual-break').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries, io) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  document.querySelectorAll('.aw-reveal, .aw-product, .aw-visual-break').forEach(function(el, index) {
    if (el.classList.contains('aw-product')) {
      el.style.transitionDelay = (index * 0.18) + 's';
    }
    observer.observe(el);
  });
});
